module.exports = __webpack_public_path__ + "static/cover.c9277ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover.jpg
// module id = 464
// module chunks = 35783957827783